export default __webpack_public_path__ + "static/media/kidofa-origin.d152c098.png";